import { DashboardListBarVariant } from '@v2/pages/dashboard/common/components/DashboardList/components/DashboardListBar/types';

export const COLOR_BY_VARIANT: Record<DashboardListBarVariant, string> = {
  [DashboardListBarVariant.Actual]: 'System/Light/Blue',
  [DashboardListBarVariant.Loss]: 'System/Light/Red',
  [DashboardListBarVariant.Gain]: 'System/Light/Green',
};
